var $input = $('.datepicker');

if ($.fn.pickadate && $input.length) {
  $input.pickadate({
    formatSubmit: 'yyyy/mm/dd',
    format: 'dd/mm/yyyy',
    closeOnSelect: true,
    closeOnClear: false,
  });

  $input.pickadate('picker');
}

$(document).on('click', '[data-toggle="lightbox"]', function (event) {
  event.preventDefault();
  $(this).ekkoLightbox();
});